import React from 'react';

import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFnsV3';

import datetimeStyles from 'components/common/form-controls/InputFieldV2/DateTime/dateTime.style';
import styles from './instaTaskSideBarItemAutocomplete.styles';

const InstaTaskSideBarItemDateTime = ({ item }) => {
  const handleChange = (newValue) => {
    try {
      item.onChange(newValue.toISOString());
    } catch (_error) {
      item.onChange(newValue);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateTimePicker
        disablePast
        showToolbar={false}
        format="dd-MM-yyyy HH:mm"
        ampm={!item.is24hr}
        slotProps={{
          popper: {
            sx: {
              ...styles.popper,
            },
          },

          textField: {
            variant: 'outlined',
            sx: {
              ...datetimeStyles.textfield,
              ...styles.textfield,
            },
          },
        }}
        value={item.value ? new Date(item.value) : null}
        onChange={handleChange}
      />
    </LocalizationProvider>
  );
};

export default InstaTaskSideBarItemDateTime;
